import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const brands = ["Finance", "Healthcare", "SaaS", "Government", "Legal", "Energy", "Manufacturing", "Retail"];

export function Partners() {
  return (
    <section id="partners" className="bg-black py-24 lg:py-32 border-t border-white/10" data-testid="partners">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-fog">
            Serving teams across regulated industries
          </p>
        </Reveal>
      </div>

      <Marquee speed={40} gradient gradientColor="#000000" gradientWidth={200} className="py-4 overflow-hidden">
        {brands.map((b) => (
          <span
            key={b}
            className="font-display text-4xl lg:text-6xl tracking-tight text-fog/70 hover:text-paper transition-colors duration-500 mx-10 lg:mx-16"
            data-testid={`brand-${b.toLowerCase()}`}
          >
            {b}
          </span>
        ))}
      </Marquee>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-24">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr] items-center rounded-3xl border border-white/10 bg-surface overflow-hidden">
          <div className="p-10 lg:p-16">
            <Reveal>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-paper max-w-[14ch]">
                Work with us as an independent contractor.
              </h2>
              <p className="mt-6 text-sm text-fog leading-relaxed max-w-md">
                Most of our specialists are independent experts who choose their
                engagements. Join a trusted network, get matched to meaningful work,
                and keep your independence.
              </p>
              <Link
                to="/register"
                data-testid="partners-apply-btn"
                className="mt-9 group inline-flex items-center gap-2 rounded-full bg-paper text-black text-sm font-medium pl-6 pr-5 py-3.5 hover:bg-white transition-colors"
              >
                Apply to the partner network
                <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </Reveal>
          </div>
          <div className="relative h-64 lg:h-[420px] overflow-hidden">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/a7857c63-2010-4de3-a354-ef80fc69c639/images/0bfbed0064a8db2b5a8b712c1f7c9399c12d825a5cbec2d1429c193baa3b33cb.png"
              alt="Consultant at work"
              className="w-full h-full object-cover grayscale"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-surface via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
